import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-card',
  templateUrl: './payments-card.component.html',
  styleUrls: ['./payments-card.component.scss']
})
export class PaymentsCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
